/**
 * Translation API endpoint constants.
 */
export const TRANSLATION_ENDPOINTS = {
    TRANSLATE_STREAM: '/translation/stream',
};
//# sourceMappingURL=endpoints.js.map